<!--

Copyright Paul B. Lucas (C) 2025   ALL RIGHTS RESERVED.
Licensed to the University of Illinois Urbana Champaign

This component is rendered when invoked from a list of assets with a linked tag
column.  This component edits assets properties on selected asset.  The primary purpose is to support audits.

Access/edit restrictions:
 Some elements of FabWeb+ data cannot be edited by ITSUpport roles.  Only 'steward' property - indirectly on save.
 Audit properties are editable by ITSupport/Auditor/admin roles.  Restricted on Reveiver roles
 

Revisions:
    03/06/2025      pblucas     initial creation
    03/07/2025      pblucas     Modified editing ability to specific user roles
    03/20/2025      pblucas     Modified with new prop for restriction on editing certain properties


-->
<template>
    <!-- master container set size relative to viewport -->
    <div class="_master_container">
        <!-- establishes column based flex container -->
 
        <div class="_container_flex_col">
            <!-- row for asset owner/steward and uuid-->           
            <p class="_p_hdr_item" style="order: 1;">Asset Steward: <span class="_p_item_text">{{ asset['steward'] }}</span></p>
            <div class="_fieldset_flex_row" style="order: 2;" v-if="restriction != 'NONE' && restriction != 'WIPE-ASSETS'"> 
                <div class="_col_40">
                    <label class="_p_hdr_item">Owning Org:</label>
                </div>
                <div class="_col_60">
                    <input class="_input" type="text" style="max-width: 100px;" v-model="asset['owner-org']">
                </div>
            </div>  
            <div class="_fieldset_flex_row" style="order: 2;" v-else>
                <div class="_col_40">
                    <p class="_p_hdr_item">Owning Org</p>
                </div>
                <div class="_col_60">
                    <p class="_p_item_text">{{ asset['owner-org']}}</p>
                </div>
            </div>          
            <p class="_p_hdr_item" style="order: 3;"> UUID: <span class="_p_item_text_diminished">{{ asset['.uuid'] }}</span></p>         
        </div>
        

        <!-- asset identifying information-->
        <div class="_fieldset_flex_row">
            <div class="_fieldset_flex_col" style="order: 1;">           
                <p class="_p_container_label" style="order: 1;">Asset Basic Information </p>      
                <!-- partially editable properties   Includes restrictions for WIPE-ASSETS and DEPLOY-ASSETS-->             
                <div class="_property_box_blue"  style="order: 2;" v-if="restriction != 'NONE' && restriction != 'WIPE_ASSETS'">
                    <form class='_form_blue'>                  
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Asset Type</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{ prettyType(asset['asset-type'])}}</p>
                            </div>
                        </div>
                         <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label" for="ABI-2">Tag/Identifying Number</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text" ><b>{{asset['tag']}}</b></p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Serial Number</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{asset['serial-no']}}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Description</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{asset['description']}}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Manufacturer</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{asset.mfg}}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Model</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{asset.model}}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Other Identifying Marks</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{asset['other-ids']}}</p>
                            </div>
                        </div>
                        <!-- allow IP editing only in NONE and DEPLOY-ASSETS cases -->
                        <div class="_row" v-if="restriction != 'WIPE-ASSETS'">
                            <div class="_col_40">
                                <label class="_label" for="ABI-7">IPV4 Address</label>
                            </div>
                            <div class="_col_60">
                                <input id="ABI-7" class="_input" type="text"  v-model="asset['ipv4-address']">
                            </div>
                        </div>
                        <div class="_row" v-else>
                            <div class="_col_50">
                                <p class="_p_item_label">IPV4 Address</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text" > {{ asset['ipv4-address'] }} </p>
                            </div>
                        </div>
                       <div class="_row" v-if="restriction != 'WIPE-ASSETS'">
                            <div class="_col_40">
                                <label class="_label" for="ABI-8" >IPV6 Address</label>
                            </div>
                            <div class="_col_60">
                                <input id="ABI-8" class="_input" type="text" required v-model="asset['ipv6-address']">
                            </div>
                        </div>
                        <div class="_row" v-else>
                            <div class="_col_50">
                                <p class="_p_item_label">IPV6 Address</p>
                            </div>
                            <div class="_col_50">
                                <p  class="_p_item_text"> {{ asset['ipv6-address'] }} </p>
                            </div>
                        </div>

                    </form>
                </div>     
                <!--  100% editable properties  -->   
                <div class="_property_box_blue"  style="order: 2;" v-if="restriction == 'NONE'">
                    <form class='_form_blue'>                  
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="ABI-1">Asset Type</label>
                            </div>
                            <div class="_col_60">
                                <select id="ABI-1" class="_select" v-model="asset['asset-type']">
                                    <option id="typeOption" class="_asset_types" disabled  >{{ prettyType(asset['asset-type']) }}</option>
                                    <option id="typeOption" class="_asset_types" v-for="(item, idx) in aAssetTypes" :value="item" > {{prettyType(item)}} </option>
                                </select>
                            </div>    
                        </div>
                         <div class="_row"> 
                            <div class="_col_40">
                                <label class="_label" for="ABI-2">Tag/Identifying Number</label>
                            </div>
                            <div class="_col_60">
                                <input id="ABI-2" class="_input" type="text" v-model="asset['tag']">
                            </div>  
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="ABI-3">Serial Number</label>
                            </div>
                            <div class="_col_60">
                                <input id="ABI-3" class="_input" type="text"  v-model="asset['serial-no']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="ABI-4">Manufacturer</label>
                            </div>
                            <div class="_col_60">
                                <input id="ABI-4" class="_input" type="text"  v-model="asset.mfg">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="ABI-5">Model</label>
                            </div>
                            <div class="_col_60">
                                <input id="ABI-5" class="_input" type="text"  v-model="asset.model">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="ABI-6">Other Identifying Marks</label>
                            </div>
                            <div class="_col_60">
                                <input id="ABI-6" class="_input" type="text"  v-model="asset['other-ids']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="ABI-7">IPV4 Address</label>
                            </div>
                            <div class="_col_60">
                                <input id="ABI-7" class="_input" type="text"  v-model="asset['ipv4-address']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="ABI-8" >IPV6 Address</label>
                            </div>
                            <div class="_col_60">
                                <input id="ABI-8" class="_input" type="text" required v-model="asset['ipv6-address']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="ABI-9">Description</label>
                            </div>
                            <div class="_col_60">
                                <textarea id="ABI-9" class="_textarea" required 
                                v-model="asset.description"></textarea>   
                            </div>
                        </div>
                    </form>
                </div>      
                <!-- auditing information -->
                <p class="_p_container_label" style="order: 3;">State of Illinois Auditing Information</p>
                <div class="_property_box_gold" style="order: 4;" v-if="restriction !='WIPE-ASSETS' ">
                    <form class='_form_gold'>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="A-1">Audit Category</label>
                            </div>
                            <div class="_col_60">
                                <select id="A-1" v-model="asset['audit-category']" class="_select" >
                                    <option id="typeOption" class="_asset_types" disabled  >{{ asset['audit-category'].toUpperCase() }}</option>
                                    <option id="typeOption" class="_asset_types" v-for="(item, idx) in aAuditCat" :value="item" > {{item.toUpperCase()}} </option>
                                </select>
                            </div>
                        </div>
                        <div class="_row_rb">
                            <div class="_generate_id">
                                <button class="_fcn_button"   @click.prevent="generateAuditDateToday()">Audit Date Today</button>
                            </div>         
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="A-2">Date of Last Audit</label>
                            </div>
                            <div class="_col_60">
                                <VueDatePicker id="A-2" class="_date_picker" v-model="asset['date-last-audit']" :format="useFormat"  />
                             </div>

                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="A-3">Machine Name</label>
                            </div>
                            <div class="_col_60">
                                <input id="A-3" class="_input" type="text"  v-model="asset['machine-name']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="A-4">Operating System Name/Type</label>
                            </div>
                            <div class="_col_60">
                                <input id="A-4" class="_input" type="text"  v-model="asset['os-type']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="A-5">Operating System Version</label>
                            </div>
                            <div class="_col_60">
                                <input id="A-5" class="_input" type="text"  v-model="asset['os-version']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="A-6">Anti-virus Name</label>
                            </div>
                            <div class="_col_60">
                                <input id="A-6" class="_input" type="text"  v-model="asset['av-name']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="A-7">Anti-virus Version</label>
                            </div>
                            <div class="_col_60">
                                <input id="A-6" class="_input" type="text"  v-model="asset['av-version']">
                            </div>
                        </div>     
                    </form>    
                </div>
                <div class="_property_box_gold" style="order: 4;" v-if="restriction == 'WIPE-ASSETS'">
                    <form class='_form_gold'>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Audit Category</p>
                            </div>
                            <div class="_col_50">
                              <p class="_p_item_text">{{  asset['audit-category'] }}</p>
                            </div>
                        </div>
                         <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Date of Last Audit</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{ asset['date-last-audit']}} </p>
                             </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Machine Name</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{asset['machine-name']}}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Operating System Name/Type</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text"> {{ asset['os-type'] }} </p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Operating System Version</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text"> {{asset['os-version']}} </p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Anti-virus Name</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text"> {{asset['av-name']}} </p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Anti-virus Version</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{ asset['av-version'] }}</p> 
                            </div>
                        </div>     
                    </form>    
                </div>

                <!-- end of left two columns-->
            </div>

            <!-- data classification -->
            <div class="_fieldset_flex_col" style="order: 2;">             
                <p class="_p_container_label" style="order: 1;">Information Security</p>
                <div class="_property_box_blue" style="order: 2;">
                    <form class='_form_blue' v-if="restriction != 'WIPE-ASSETS'  && bWipable">
                        <div class="_row" >
                            <div class="_col_8">
                                <input type="checkbox" class="_checkbox" for="IS-1" v-model="asset['has_sensitive_data']" value="true">
                            </div>
                            <div class="_col_90">
                                <label id="IS-1" class="_check_label">Asset Contains Sensitive Information</label>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="IS-2">Data Classification</label>
                            </div>
                            <div class="_col_60">
                                <select id="IS-2" v-model="asset['data-class']" class="_select" >
                                    <option id="typeOption" class="_asset_types" disabled  >{{ asset['data-class'] }}</option>
                                    <option id="typeOption" class="_asset_types" v-for="(item, idx) in aDataClass" :value="asset['data-class']" > {{item.toUpperCase()}} </option>
                                </select>
                            </div>
                        </div>
                    </form>
                    <form class="_form_blue" v-if="restriction == 'WIPE-ASSETS'  && bWipable">
                        <div class="_row">
                            <div class="_assets_check_label_table_cell">
                                <p class="_p_item_label">Asset contains sensitive data</p>
                            </div>
                            <div class="_assets_check_table_cell">
                                <div class="_checks"  v-if="asset['has-sensitive-data']"><img src="@/assets/check-green.png" width="10" /></div>
                                <div class="_checks"  v-else><img src="@/assets/red-x.png" width="10" /></div> 
                            </div>           
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <p class="_p_item_label">Data Classification</p>
                            </div>
                            <div class="_col_40">
                                <p class="_p_item_text">{{ asset['data-class'] }}</p>
                            </div>
                        </div>
                        <div class="_row" v-if="restriction == 'WIPE-ASSETS' && bWipable">
                            <div class="_col_8">
                                <input type="checkbox" class="_checkbox" for="IS-3" v-model="asset['disk-wiped']" 
                                    value="true" @change="emitWipe(asset['disk-wiped'])">
                            </div>
                            <div class="_col_90">
                                <label id="IS-3" class="_check_label">Certified: Disk Wiped</label>
                            </div>

                        </div>
                        <div class="_row" v-if="restriction == 'WIPE-ASSETS'  && bWipable">
                            <div class="_col_40">
                                <p class="_p_item_label">Disk Wiped By</p>
                            </div>
                            <div class="_col_40">
                                <p class="_p_item_text">{{ asset['disk-wiped-by'] }}</p>
                            </div>     
                        </div>
                        <div class="_row" v-if="restriction == 'WIPE-ASSETS'  && bWipable">
                            <div class="_col_40">
                                <p class="_p_item_label">Date Disk Wiped</p>
                            </div>
                            <div class="_col_40">
                                <p class="_p_item_text">{{ asset['disk-wiped-date'] }}</p>
                            </div>     
                        </div>
                    </form>
                    <!-- ignore data classification if not a CI with disk (Assume RAM volitile) -->
                    <form class="_form_blue" v-if="!bWipable">
                        <p class="_p_instructions">This asset is not a configuration item.  No storage.</p>
                    </form>
                </div>
                <p class="_p_container_label" style="order: 3;">FabWeb+ Data</p>
                <div class="_property_box_blue" style="order: 4;" v-if="restriction != 'NONE'">
                    <div class="_form_blue">
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Chart</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{ asset['chart'] }}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Original Purchase Cost</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">${{asset['cost'].toFixed(2)}}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Property Category</p>
                            </div>
                            <div class="_col_50">   
                                <p class="_p_item_text">{{ asset['category'] }}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Origination ID (OTag)</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{ asset['otag'] }}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Banner Location Code</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{ asset['location'] }}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Banner Location Detail</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{ asset['location-detail'] }}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Invoice Number</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{ asset['invoice-number'] }}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">IT Data (reserved)</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{ asset['it-data'] }}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <!-- area for the asset notes -->
                            <div class="_col_50">
                                <p class="_p_item_label">Notes</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text_ellipsis">{{ asset['notes'] }}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Original Item ID</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{ asset['orig-item-id'] }} </p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Purchase Date</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{ prettyDate(asset['purchase-date']) }}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Replacement Cycle (yrs)</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{ asset['replacement-cycle'] }}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Asset Status</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{ asset['status'] }}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Unit</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{ asset['unit'] }}</p>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_50">
                                <p class="_p_item_label">Warranty Expiration Date</p>
                            </div>
                            <div class="_col_50">
                                <p class="_p_item_text">{{ asset['warranty-expiration'] }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="_property_box_blue" style="order: 4;" v-if="restriction == 'NONE'">
                    <form class='_form_blue'>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-1">Chart</label>
                            </div>
                            <div class="_col_60">
                                <select id="FW-1" v-model="asset['chart']" class="_select" >
                                    <option id="typeOption" class="_asset_types" disabled  >{{ asset['chart'] }}</option>
                                    <option id="typeOption" class="_asset_types" v-for="(item, idx) in aChartEnums" :value="asset['chart']" > {{item}} </option>
                                </select>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-2" >Original Purchase Cost</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-2" class="_input" type="text" required v-model="asset['cost']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-3">Property Category</label>
                            </div>
                            <div class="_col_60">
                                <select id="FW-3" v-model="asset['category']" class="_select" >
                                    <option id="typeOption2" class="_asset_types" disabled  >{{ asset['category'] }}</option>
                                    <option id="typeOption2" class="_asset_types" v-for="(item, idx) in aPropClass" :value="item" > {{item}} </option>
                                </select>

                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-4" >Origination ID (OTag)</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-4" class="_input" type="text" required v-model="asset['otag']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-5" >Banner Location Code</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-5" class="_input" type="text" required v-model="asset['location']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-6" >Banner Location Detail</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-6" class="_input" type="text" required v-model="asset['location-detail']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-7" >Invoice Number</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-7" class="_input" type="text" required v-model="asset['invoice-number']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-8" >IT Data (reserved)</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-8" class="_input" type="text" required v-model="asset['it-data']">
                            </div>
                        </div>
                        <div class="_row">   
                            <!-- area for the asset notes -->
                            <div class="_col_40">
                                <label class="_label" for="FW-9">Notes</label>
                            </div>
                            <div class="_col_60">
                                <textarea id="FW-9" class="_textarea"  
                                    v-model="asset['notes']" >
                                </textarea>      
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-10" >Original Item ID</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-10" class="_input" type="text" required v-model="asset['orig-item-id']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-11" >Purchase Date</label>
                            </div>
                            <div class="_col_60">
                                <VueDatePicker id="FW-11" class="_date_picker" v-model="asset['purchase-date']" :format="useFormat"  />
                             </div>

                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-12" >Replacement Cycle (yrs)</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-12" class="_input" type="text" required v-model="asset['replacement-cycle']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-13">Asset Status</label>
                            </div>
                            <div class="_col_60">
                                <select id="FW-13" v-model="asset['status']" class="_select" >
                                    <option id="typeOption3" class="_asset_types" disabled  >{{ asset['status'] }}</option>
                                    <option id="typeOption3" class="_asset_types" v-for="(item, idx) in aAssetStatus" :value="item" > {{item}} </option>
                                </select>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-14" >Unit</label>
                            </div>
                            <div class="_col_60">
                                <input id="FW-14" class="_input" type="text" required v-model="asset['unit']">
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_40">
                                <label class="_label" for="FW-15" >Warranty Expiration Date</label>
                            </div>
                            <div class="_col_60">
                                <VueDatePicker id="FW-15" class="_date_picker" required v-model="asset['warranty-expiration']" :format="useFormat"  />
                             </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- Boolean configuration checks -->
        <div class="_fieldset_flex_row">
            <div class="_fieldset_flex_col" style="order: 1;">
                <p class="_p_container_label" style="order: 1;">Audit Configuration Checks</p>
                <div class="_property_box_gold" style="order: 2;">
                    <br />
                    <form class='_form_gold'>
                        <div class="_row">
                            <div class="_col_8">
                                <input type="checkbox" class="_checkbox" for="ACC-1" v-model="asset['av-installed']" value="true">
                            </div>
                            <div class="_col_90">
                                <label id="ACC-1" class="_check_label">Anti-virus Installed and Operating</label>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_8">
                                <input type="checkbox" class="_checkbox" for="ACC-2" v-model="asset['firewall-active']" value="true">
                            </div>
                            <div class="_col_90">
                                <label id="ACC-2" class="_check_label">Firewall Installed, Configured, and Operating</label>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_8">
                                <input type="checkbox" class="_checkbox" for="ACC-3" v-model="asset['user-is-admin']" value="true">
                            </div>
                            <div class="_col_90">
                                <label id="ACC-3" class="_check_label">User is Admin on Machine</label>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_8">
                                <input type="checkbox" class="_checkbox" for="ACC-4" v-model="asset['identified-as-uiuc']" value="true">
                            </div>
                            <div class="_col_90">
                                <label id="ACC-4" class="_check_label">Asset Identified as UIUC Property</label>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_8">
                                <input type="checkbox" class="_checkbox" for="ACC-5" v-model="asset['crowdstrike-active']" value="true">
                            </div>
                            <div class="_col_90">
                                <label id="ACC-5" class="_check_label">CrowdStrike Falcon Sensor Active</label>
                            </div>
                        </div>
                        <div class="_row">
                            <div class="_col_8">
                                <input type="checkbox" class="_checkbox" for="ACC-6" v-model="asset['disk-encrypted']" value="true">
                            </div>
                            <div class="_col_90">
                                <label id="ACC-6" class="_check_label">Disk is Encrypted</label>
                            </div>
                        </div>
                    </form>       
                </div>   
            </div>   
        </div>
    </div>
</template>

<script>
    import {ref, computed}              from 'vue'
    import { useStore }       from 'vuex'
  
    import useAssetsAPI                 from    '@/composables/useAssetsAPI'
    import useDateHelpers               from    '@/composables/useDateHelpers'
    import useNextAvailableNumberAPI    from    '@/composables/useNextAvailableNumberAPI'

    // calendar date picket widget
    // See https://vue3datepicker.com/
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css';

    // import enumerations
    import Configs                      from    '@/configuration/form-options.json'
   
    export default {
        components: {
            VueDatePicker
        },
        props: [
            'asset',
            'restriction'
        ],

        emits: [
            'markWiped'
        ],
    
        setup(props)    {

            const {assetResults, assetKeyData, fetchAssetsOnQuery, fetchAssetsOnOrgs, storeAsset} = useAssetsAPI()
            const store = useStore()

            const user                  =   computed( () => store.state.user)
            const systemAdministrator   =   computed( () => store.state.user['is-sys-admin'])
            const deptAdministrator     =   computed( () => store.state.user['is-dept-admin'])
            const activeRole            =   computed( () => store.state.user['active-role'])


            const aAssetTypes       =   ref([])
            const aDataClass        =   ref([])
            const aAuditCat         =   ref([])
            const aChartEnums       =   ref([])
            const aPropClass        =   ref([])
            const aAssetStatus      =   ref([])

            const configs           =   ref([])
            configs.value           =   Configs
            aAssetTypes.value       =   configs.value['asset-types']
            aDataClass.value        =   configs.value['data-classification-types']
            aAuditCat.value         =   configs.value['audit-categories']
            aChartEnums.value       =   configs.value['chart-enums']
            aPropClass.value        =   configs.value['property-class']
            aAssetStatus.value      =   configs.value['asset-status']

            const bWipable           =   computed( () => {
                let b = false
                if(     props.asset['asset-type'] == 'laptop'
                    ||  props.asset['asset-type'] == 'computer workstation'
                    ||  props.asset['asset-type'] == 'usb attached storage'
                    ||  props.asset['asset-type'] == 'network attached storage'
                    ||  props.asset['asset-type'] == 'server')    {
                        b = true
                    }
                return b
            })

            return {aAssetTypes, aDataClass, aAuditCat, aChartEnums, aPropClass, aAssetStatus, activeRole, bWipable}
        },
        data() {
            return {
            }
        },
        methods:  {
            prettyDate(date)     {
                const {makePrettyDate}      =   useDateHelpers()
                return makePrettyDate(date)  
            },
            // Function: converts status enumeration to more readable 
            prettyType(s) {
                if (!s) return ""
                s = s.replaceAll('_',' ')
                let aW = s.toLowerCase().split(' ')
                for (let i = 0; i < aW.length; i++) {
                    aW[i] = aW[i].charAt(0).toUpperCase() + aW[i].slice(1);
                }
                return aW.join(' ')
            },
            generateAuditDateToday()    {
                
                let date = new Date().toString()
                this.asset['date-last-audit'] = this.prettyDate(date)
            },         
            useFormat(date) {
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const year = date.getFullYear();
                return `${month}/${day}/${year}`;
            },
            emitWipe(value) {
                this.$emit('markWiped', value)
            }
        },

        // hooks
        beforeMount() {
        },
        mounted() {
        },
        updated() {
        }
    }
</script>

<style scoped>

    ._master_container   {
        width: 100%;
        height: 90%;
        font-family:Monserrat, Avenir, Helvetica, Arial, sans-serif;
        margin: 5px auto;
        padding: 5px;  
    }

    ._container_flex_col {
        width: 50%;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin: 5px 25px;
        padding: 5px;  
    }
    ._fieldset_flex_row {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        margin: 0;
        padding: 0;  
    }
    ._fieldset_flex_col {
        width: 50%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: flex-start;
        margin: 5px 25px;
        padding: 5px;  
    }
    ._form_blue {     
        max-width: 100%;
        margin: 0;
        background: #BFC9D9;
        text-align: left; 
        padding: 5px;
        border-radius: 10px;
    }
    ._form_gold {
        max-width: 100%;
        margin: 0;
        background: #f9da98;
        text-align: left; 
        padding: 5px;
        border-radius: 10px;
    }
    ._p_container_label {
        color: #13294B;
        font-weight: bold;
        font-size: 0.9em;
        margin: 10px 0 5px 0;
        text-align: left;
        padding: 0;
    }
    br {
        margin: 0;
    }
    ._date_picker {
        --dp-font-size: 0.8em;
        --dp-input-padding: 6px 10px 6px 10px;
        --dp-text-color: blue;
    }
    ._p_item_label {
        display: inline-block;
        color: #13294B;
        font-size: 0.8em;
        font-weight: bold;
        text-align: left;
        margin: 0;
        padding: 2px 0;
    }
    ._p_hdr_item {
        color: #13294B;
        font-size: 0.9em;
        font-weight: bold;
        text-align: left;
        margin: 0;
        padding: 0 2px;
    }
    ._p_item_text {
        color: black;
        font-size: 0.8em;
        font-weight: normal;
        text-align: left;
        margin: 1px 0 0 0;
        padding: 0 3px;
    }
    ._p_item_text_ellipsis {
        color: black;
        font-size: 0.8em;
        font-weight: normal;
        text-align: left;
        text-overflow: elipsis;
        margin: 1px 0 0 0;
        padding: 0 3px;
    }
    ._p_item_text_diminished {
        color: black;
        font-weight: normal;
        font-size: 0.9em;
        text-align: left;
        padding: 0 3px;
    }
    ._property_box_blue {
        background: #BFC9D9;
        border-style: solid;
        border-width: 2px;
        border-color: #13294B;
        text-align: left;
        padding: 0 5px;
    }
    ._property_box_gold {
        background: #f9da98;
        border-style: solid;
        border-width: 2px;
        border-color: #13294B;
        text-align: left;
        padding: 0 5px;
    }
    ._p_instructions {
        text-align: justify;
        /* color: #13294B; */
        color: black;
        font-size: 0.8em;
        font-weight: normal;
        margin: 2px 0;
        padding: 10px 2px;
    }

    ._row_rb {
        padding: 0;
    }
    ._row {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        clear: both;
    }
    ._input[type=text], ._select, ._asset_types, ._textarea {
        width: 100%;
        padding: 2px 10px;
        border: 1px solid #ccc;
        color: black;
        border-radius: 4px;
        box-sizing: border-box;
        resize: vertical;
    }
    ._asset_types:disabled {
        color: #006230;
    }
    ._assets_check_label_table_cell {
        display: table-cell;
        min-width:70%;
        text-align: left;
        margin: 0;
        padding: 2px 0 2px 10px;
    }
    ._assets_check_table_cell {
        display: table-cell;
        margin: 0;
        padding: 2px 0 2px 10px;
    }
    ._checks {
        width: 5%;
        text-align: center;
        margin: 0;
        padding: 0;
    }

    ._label {
        display: inline-block;
        color: #13294B;
        font-weight: bold;
        font-size: 0.8em;
        text-align: left;
        padding: 2px 0;  
    }
    ._label:after {
        content:":";
    }
    ._check_label { 
        color: #13294B;
        font-weight: bold;
        font-size: 0.8em;
        text-align: left;
        margin: 2px  2px 15px;
        padding: 2px 5px;
    }
    ._checkbox {
        display: inline;
        width: 25px;
        margin: 2px 0;
        padding: 0;
        
    }
    /* checkbox styling */
    ._check {
        display: inline;
        width: 25px;
        margin: 5px auto;
        padding: 0;
        
    }
    ._generate_id {
        margin: 3px 0 0 0;
        padding: 0;
        float: right;
    }
    ._fcn_button {
        margin: 0;
        padding: 0 2px;
        font-size: 0.7em;
        background-color:#13294B;
        color: #E8E9EB;
        border-style: solid;
        border-width: 1px;
        border-radius: 4px;
        border-color: #13294B;
    }
    ._fcn_button:hover {
        background-color:#E8E9EB;
        color: black;
    }
   
    
    /* text styling for responsive form */
    /*  can inherit from calling views (List ASsets, ListMyASsets, DeployAssets)  */
    ._col_8 {
        width:8%;
        margin-top: 5px;
    }

    ._col_40 {
        width: 40%;
        margin-top: 5px;
        text-align: left;
    }
    ._col_50 {
        width: 50%;
        margin-top: 5px;
        padding: 2px 0 2px 10px;
    }
    ._col_60 {
        width: 60%;
        margin-top: 5px;
    }
    ._col_90 {
        width: 90%;
        margin-top: 5px;
    }
    @media screen and (max-width: 620px) {
        ._col_50, ._col_40, ._col_60 {
            width: 100%;
            margin-top: 0;
        }
        ._row {
            flex-wrap: wrap;
        }
    }
    @media screen and (max-width: 800px) {
        ._fieldset_flex_row {
            flex-wrap: wrap;  
        }
        ._col_50 {
            width: 100%;
        }
    }


    
    
</style>